import { useState } from 'react';

import { get } from 'js/lib/user';

import type { NaptimeThirdPartyOrganizationFromSlugFragment } from 'bundles/enterprise-legacy-learner-home/queries/__generated__/EnterpriseProgramBySlugQuery';
import { useNaptime } from 'bundles/naptimejs';
import EnterpriseEventsV1 from 'bundles/naptimejs/resources/enterpriseEvents.v1';
import useMarketingConsentData from 'bundles/user-consent/hooks/useMarketingConsentData';

const ENTERPRISE_USE_CONSENT = 'ENTERPRISE_OF_USE_CONSENT';

type EnterpriseEventsNaptimeData = {
  tou?: {
    timestamps?: Array<number>;
  };
};

export const useShowEnterpriseTermsOfUseModal = (
  thirdPartyOrganization?: NaptimeThirdPartyOrganizationFromSlugFragment
) => {
  const userId = get().id;
  const [showTermsOfUseModal, setShowTermsOfUseModal] = useState<boolean>(true);
  const {
    isEnterpriseAdmin,
    shouldShowCCPAMarketingConsent,
    shouldShowGDPRMarketingConsent,
    isLoading: isMarketingConsentDataLoading,
  } = useMarketingConsentData(get().id);

  const { data: enterpriseEvents, pending: isFetchingEnterpriseEvents } = useNaptime<EnterpriseEventsNaptimeData>(
    () => {
      if (!thirdPartyOrganization || !userId) return {};
      return {
        tou: EnterpriseEventsV1.get(
          `${userId}~organizationEventKey!~${thirdPartyOrganization.id}!!!~${ENTERPRISE_USE_CONSENT}`
        ),
      };
    }
  );

  const requiresThirdPartyTermsOfConsent = Boolean(enterpriseEvents.tou?.timestamps?.length === 0);
  const requiresConsumerTermsOfConsent = shouldShowCCPAMarketingConsent || shouldShowGDPRMarketingConsent;

  return {
    setShowEnterpriseTermsOfUseModal: setShowTermsOfUseModal,
    showEnterpriseTermsOfUseModal:
      showTermsOfUseModal && (requiresConsumerTermsOfConsent || requiresThirdPartyTermsOfConsent),
    isLoading: isFetchingEnterpriseEvents || isMarketingConsentDataLoading,
    isEnterpriseAdmin,
    shouldShowCCPAMarketingConsent,
    shouldShowGDPRMarketingConsent,
    shouldShowThirdPartyTermsOfConsent: requiresThirdPartyTermsOfConsent,
  };
};
